module.exports = __webpack_public_path__ + "img/bg-sobre.eb47a730.jpg";